import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  intro?: string;
  align?: 'left' | 'center';
  id?: string;
};
export function SectionHeading({
  eyebrow,
  title,
  intro,
  align = 'center',
  id
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  return <div className={isCenter ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl'} data-id="element-309" data-mp="3jzx7u9uywqu5">
      {eyebrow ? <p className={`flex items-center gap-4 ${isCenter ? 'justify-center' : ''}`} data-id="element-310" data-mp="bkn652uzpnmw">
          <span className="h-px w-10 shrink-0 bg-gold-deep/70" aria-hidden="true" data-id="element-311" data-mp="bmpwxp3yvkso" />
          <span className="gold-shine font-display text-xl font-medium italic tracking-wide sm:text-2xl" data-id="element-312" data-mp="glj7p9rvcxp5">
            {eyebrow}
          </span>
          <span className="h-px w-10 shrink-0 bg-gold-deep/70" aria-hidden="true" data-id="element-313" data-mp="6svdmms9x7u4" />
        </p> : null}
      <h2 id={id} className="gold-shine mt-4 font-display text-3xl font-semibold leading-[1.12] sm:text-4xl lg:text-[2.9rem]" data-id="element-314" data-mp="uizg2qtq71jj">
        {title}
      </h2>
      {intro ? <p className="mt-5 text-base leading-relaxed text-neutral-300 sm:text-lg" data-id="element-315" data-mp="zbsnxnkhqpzu">{intro}</p> : null}
      <div className={`gold-rule mt-7 h-px w-40 ${isCenter ? 'mx-auto' : ''}`} aria-hidden="true" data-id="element-316" data-mp="1t7mg7dzrny4w" />
    </div>;
}